var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMagnifyingGlassMinus = function SvgIconMagnifyingGlassMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 10.875a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 10.875a8.875 8.875 0 1 1 15.818 5.529l3.889 3.889a1 1 0 0 1-1.415 1.414l-3.889-3.889A8.875 8.875 0 0 1 2 10.875M10.875 4a6.875 6.875 0 1 0 0 13.75 6.875 6.875 0 0 0 0-13.75",
    clipRule: "evenodd"
  }))));
};
export default SvgIconMagnifyingGlassMinus;